/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 各端查询钱包余额信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: payment.PaymentWayDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/wallet/balance`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
